const en = {
  // Navbar
  "nav.services": "Services",
  "nav.projects": "Projects",
  "nav.calculator": "Cost Calculator",
  "nav.resources": "Resources",
  "nav.process": "Process",
  "nav.about": "About",
  "nav.careers": "Careers",
  "nav.contact": "Contact",
  "nav.blog": "Blog",
  "nav.getStarted": "Get Started",
  "nav.siteVisit": "Book a Site Visit",
  "nav.getQuote": "Get a Quote",

  // Hero
  "hero.eyebrow": "Yaoundé, Cameroon",
  "hero.headline1": "Engineering",
  "hero.headline2": "Built to Last.",
  "hero.headline3": "Services Built to Deliver.",
  "hero.sub": "KIVE SARL is a licensed Cameroonian construction company based in Yaoundé, trusted by governments, schools, and private developers to deliver complex construction management, technical maintenance, and heavy machinery rental projects — on time, within budget, and without compromise.",
  "hero.cta.quote": "Request a Quote",
  "hero.cta.services": "Explore Services",
  "stats.experience": "Years of Experience",
  "stats.projects": "Projects Delivered",
  "stats.engineers": "Expert Engineers",
  "stats.satisfaction": "Client Satisfaction",

  // Why Choose Us
  "why.eyebrow": "Why Choose Us",
  "why.title": "The Difference Is in How We Work",
  "why.sub": "We don't just build structures — we build confidence. Every engagement with KIVE SARL is defined by rigor, transparency, and accountability that delivers real-world results.",
  "why.badge.title": "Certified Excellence",
  "why.badge.sub": "Recognized by public and private clients across Cameroon",

  // Services
  "services.eyebrow": "Our Services",
  "services.title": "What We Do Best",
  "services.sub": "Three core disciplines. One accountable team. Built for demanding projects in Cameroon.",
  "services.cta.details": "Full Service Details",
  "services.cta.quote": "Get a Quote",

  // Process
  "process.eyebrow": "How We Work",
  "process.title": "From First Call to Final Handover",
  "process.sub": "A clear, structured process so you always know what to expect — and when to expect it.",
  "process.cta": "Start the Process",

  // Contact
  "contact.eyebrow": "Contact Us",
  "contact.title": "Let's Talk About Your Project",
  "contact.sub": "Send us a message and a project manager will follow up within 24 hours.",
  "contact.info.title": "Contact Information",
  "contact.info.office": "Office",
  "contact.info.phone": "Phone",
  "contact.info.phone2": "Phone 2",
  "contact.info.whatsapp": "WhatsApp",
  "contact.info.email": "Email",
  "contact.info.hours": "Working Hours",
  "contact.info.officeVal": "Entrée Frazati, Damas\nYaoundé, Cameroon",
  "contact.info.phoneVal": "(+237) 677-009-408\n(+237) 675-095-808",
  "contact.info.hoursVal": "Mon–Fri: 8:00–17:00\nSaturday: 9:00–14:00",
  "contact.info.follow": "Follow Us",
  "contact.form.name": "Full Name",
  "contact.form.email": "Email Address",
  "contact.form.phone": "Phone Number",
  "contact.form.subject": "Subject",
  "contact.form.message": "Message",
  "contact.form.send": "Send Message",
  "contact.form.sending": "Sending...",
  "contact.form.required": "required",
  "contact.form.title": "Message KIVE SARL",
  "contact.form.emailAlt": "Please email us directly at",
  "contact.form.whatsappBtn": "Message us on WhatsApp",
  "contact.form.successTitle": "Message Received",
  "contact.form.successSub": "Thank you for reaching out. A member of our team will contact you within 24 hours to discuss your project.",
  "contact.success.title": "Message Received",
  "contact.success.sub": "Thank you for reaching out. A member of our team will contact you within 24 hours to discuss your project.",
  "contact.hero.eyebrow": "Get In Touch",
  "contact.hero.title1": "Contact KIVE SARL",
  "contact.hero.title2": "Yaoundé, Cameroon",
  "contact.hero.sub": "Ready to start your construction or maintenance project? Reach out by phone, WhatsApp, email, or the form below. Our team responds within 24 hours.",
  "contact.cta.title": "Prefer to Call? We Are Here.",
  "contact.cta.sub": "Our project managers are available Monday to Saturday to discuss your construction, maintenance, or machinery rental needs.",

  // Final CTA
  "cta.eyebrow": "Ready to Build?",
  "cta.title1": "Your Project Deserves",
  "cta.title2": "a Team That Delivers.",
  "cta.sub": "Whether you're breaking ground on a new development or maintaining critical infrastructure, KIVE SARL brings the expertise, equipment, and accountability to get it done right. Let's talk about your project today.",
  "cta.btn.consult": "Request a Free Consultation",
  "cta.badge1": "No Obligation Quote",
  "cta.badge2": "24h Response",
  "cta.badge3": "Expert Team",

  // Video section
  "video.eyebrow": "See Us In Action",
  "video.title": "Heavy Machinery, Professional Hands.",
  "video.body": "Watch our team operate heavy excavation and earthmoving equipment on a live site in Cameroon. This is what professional machinery rental looks like — certified operators, well-maintained fleet, zero downtime.",
  "video.bullet1": "Certified operators on every machine",
  "video.bullet2": "Full fleet available for short and long-term rental",
  "video.cta": "View Machinery Services",

  // FAQ section
  "faq.eyebrow": "Questions",
  "faq.title": "Frequently Asked Questions",
  "faq.sub": "Everything you need to know before getting in touch.",

  // Blog page
  "blog.hero.eyebrow": "Blog & Insights",
  "blog.hero.title": "Construction Tips & Project Case Studies",
  "blog.hero.sub": "Practical advice, regulatory guides, and cost analysis for building smart in Cameroon.",
  "blog.featured": "Featured Articles",
  "blog.all": "All Articles",
  "blog.cta.title": "Need Personalised Advice?",
  "blog.cta.sub": "Our engineering team is ready to answer your questions and guide your project.",
  "blog.cta.btn": "Talk to an Expert",
  "blog.readMore": "Read More",
  "blog.backToBlog": "← Back to Blog",
  "blog.readTime": "read",
  "blog.byLine": "KIVE SARL Editorial",
  "blog.articleCTA.title": "Need Help With Your Project?",
  "blog.articleCTA.sub": "Contact our engineering team for a free consultation.",
  "blog.articleCTA.btn": "Talk to an Expert",
  "blog.related": "Related Articles",
  "blog.backToAll": "Back to All Articles",

  // Brochure page
  "brochure.hero.eyebrow": "Company Profile",
  "brochure.hero.title": "Download Our Services Brochure",
  "brochure.hero.sub": "Get our full company profile as a PDF — services, project portfolio, team overview, and contact details. Share it with your team or keep it for reference.",
  "brochure.form.title": "Request the Brochure",
  "brochure.form.name": "Full Name",
  "brochure.form.email": "Email Address",
  "brochure.form.company": "Company / Organisation",
  "brochure.form.projectType": "Project Type",
  "brochure.form.submit": "Send Me the Brochure",
  "brochure.form.sending": "Sending...",
  "brochure.success.title": "Your brochure is on its way!",
  "brochure.success.sub": "Check your inbox within 24 hours. If you don't receive it, email info@kive-cm.com.",
  "brochure.noForm": "Please email us directly at info@kive-cm.com",
  "brochure.trust.noSpam": "No spam, ever",
  "brochure.trust.clients": "Used by 80+ clients",
  "brochure.trust.languages": "Available in English & French",

  // Questionnaire page
  "questionnaire.hero.eyebrow": "Free Quote",
  "questionnaire.hero.title": "What Kind of Project Do You Have?",
  "questionnaire.hero.sub": "Answer a few quick questions and our team will prepare a tailored proposal for you.",
  "questionnaire.step1": "Your Project",
  "questionnaire.step2": "Your Details",
  "questionnaire.step3": "Submit",
  "questionnaire.form.projectType": "Project Type",
  "questionnaire.form.location": "Project Location",
  "questionnaire.form.budget": "Approximate Budget",
  "questionnaire.form.timeline": "Desired Timeline",
  "questionnaire.form.description": "Project Description",
  "questionnaire.form.name": "Full Name",
  "questionnaire.form.email": "Email Address",
  "questionnaire.form.phone": "Phone Number",
  "questionnaire.form.company": "Company / Organisation",
  "questionnaire.form.submit": "Request a Quote",
  "questionnaire.form.sending": "Submitting...",
  "questionnaire.form.back": "Back",
  "questionnaire.form.continue": "Continue",
  "questionnaire.success.title": "Request Submitted!",
  "questionnaire.success.sub": "Thank you! Our team will review your project and get back to you within 24 hours with a tailored proposal.",
  "questionnaire.noForm": "Please email us directly at info@kive-cm.com",

  // Site Visit Banner
  "siteVisit.eyebrow": "Free Site Visit",
  "siteVisit.title": "Not Sure Where to Start? We Come to You.",
  "siteVisit.body": "Our engineers will visit your site or plot — anywhere in Yaoundé — at no cost and no obligation. We assess conditions, answer your questions, and give you an honest expert opinion before you commit to anything.",
  "siteVisit.cta": "Book a Free Site Visit",
  "siteVisit.tagline1": "No cost. No commitment.",
  "siteVisit.tagline2": "Yaoundé & surrounding areas.",

  // Contact section alternative
  "contact.alt.divider": "— or —",
  "contact.alt.cta": "Book a Free Site Visit Instead",

  // Footer
  "footer.links": "Quick Links",
  "footer.newsletter.title": "Stay Updated",
  "footer.newsletter.sub": "Get project updates and construction insights from our team.",
  "footer.newsletter.placeholder": "Your email address",
  "footer.newsletter.btn": "Subscribe",
  "footer.newsletter.subscribing": "Subscribing...",
  "footer.newsletter.done": "You're subscribed. Thank you!",
  "footer.copyright": "© 2026 KIVE SARL. All rights reserved. Yaoundé, Cameroon.",
  "footer.desc": "Licensed construction management, technical maintenance, and heavy machinery rental services in Yaoundé, Cameroon. Trusted by governments, institutions, and private clients since 2007. Call (+237) 677-009-408.",

  // Cookie Consent
  "cookieConsent.label": "Cookie consent",
  "cookieConsent.message": "This website uses cookies to provide essential functionality and improve your experience. By continuing to browse, you agree to our use of cookies.",
  "cookieConsent.accept": "Accept",
  "cookieConsent.dismiss": "Decline",
  "cookieConsent.learnMore": "Privacy Policy",

  // Calculator page
  "calc.hero.badge": "Free Tool",
  "calc.hero.title1": "Building Cost",
  "calc.hero.title2": "Calculator",
  "calc.hero.sub": "Get a realistic construction cost estimate for your Cameroon project in under 2 minutes. Tailored to local labour, materials, and city pricing.",
  "calc.hero.badge1": "Results in 2 minutes",
  "calc.hero.badge2": "Cameroon pricing",
  "calc.hero.badge3": "Costs in FCFA",
  "calc.step.type": "Type",
  "calc.step.size": "Size",
  "calc.step.spec": "Specs",
  "calc.step.location": "Location",
  "calc.step.extras": "Extras",
  "calc.type.title": "What are you building?",
  "calc.type.sub": "Select the type of building you are planning.",
  "calc.size.title": "How big is your project?",
  "calc.size.sub": "Enter the floor area per level and number of floors.",
  "calc.size.area": "Floor Area (per level):",
  "calc.size.areaNote": "This is the built-up area per floor, not the plot size.",
  "calc.size.floors": "Number of Floors",
  "calc.size.bedrooms": "Number of Bedrooms",
  "calc.spec.title": "Specifications",
  "calc.spec.sub": "Choose your finish level, foundation type, and roofing.",
  "calc.spec.finish": "Finish Level",
  "calc.spec.foundation": "Foundation Type",
  "calc.spec.roof": "Roof Type",
  "calc.location.title": "Where are you building?",
  "calc.location.sub": "Location affects labour costs, transport, and material availability.",
  "calc.extras.title": "Any extras?",
  "calc.extras.sub": "Select any additional features to include in your estimate.",
  "calc.extras.pool": "Swimming Pool",
  "calc.extras.fence": "Perimeter Fence & Gate",
  "calc.extras.generator": "Backup Generator",
  "calc.extras.borehole": "Borehole / Water Well",
  "calc.extras.note.title": "Note:",
  "calc.extras.note.body": "Extra costs are approximate averages for Cameroon. Actual costs depend on size, depth, and supplier.",
  "calc.nav.back": "Back",
  "calc.nav.next": "Next",
  "calc.nav.calculate": "Calculate Cost",
  "calc.results.estimatedCost": "Estimated Total Cost",
  "calc.results.totalArea": "total built area",
  "calc.results.floors": "floor(s)",
  "calc.results.beds": "bed(s)",
  "calc.results.breakdown": "Cost Breakdown",
  "calc.results.foundation": "Foundation",
  "calc.results.structure": "Structure & Roofing",
  "calc.results.electrical": "Electrical Works",
  "calc.results.plumbing": "Plumbing & Sanitation",
  "calc.results.finishing": "Finishing & Fittings",
  "calc.results.extras": "Extras & Additions",
  "calc.results.contingency": "Contingency (12%)",
  "calc.results.total": "Total Estimate",
  "calc.results.disclaimer.title": "Disclaimer",
  "calc.results.disclaimer.body": "This estimate is based on 2025/2026 Cameroon construction data. Actual costs depend on soil conditions, material prices at time of purchase, site access, and contractor rates. Always commission a formal Bill of Quantities from a qualified quantity surveyor before committing to a budget.",
  "calc.results.cta.title": "Get a Precise Quote",
  "calc.results.cta.sub": "Our team can provide a detailed, site-specific cost plan for your project. Contact us for a free consultation.",
  "calc.results.cta.btn": "Request a Free Consultation",
  "calc.results.facts.title": "Good to Know",
  "calc.results.facts.f1": "Material prices in Cameroon can fluctuate 10–20% seasonally — lock in prices early.",
  "calc.results.facts.f2": "A 12% contingency is standard practice for Cameroonian construction projects.",
  "calc.results.facts.f3": "Douala typically costs 5–10% more than Yaoundé due to higher labour demand.",
  "calc.results.facts.f4": "Professional fees (architect, engineer, surveyor) are not included — budget an additional 8–12%.",
  "calc.results.recalculate": "Start a New Estimate",
  "calc.faq.eyebrow": "Questions",
  "calc.faq.title": "Frequently Asked Questions",
  "calc.faq.q1": "How accurate is this estimate?",
  "calc.faq.a1": "This calculator provides a ballpark estimate based on real Cameroon construction data from 2025/2026. Expect accuracy within ±20–30%. For a precise budget, you need a formal Bill of Quantities from a qualified quantity surveyor.",
  "calc.faq.q2": "Does this include land cost?",
  "calc.faq.a2": "No. Land purchase, titling fees, and plot preparation costs are not included. These vary enormously by location and must be budgeted separately.",
  "calc.faq.q3": "What about professional fees?",
  "calc.faq.a3": "Architect, structural engineer, and quantity surveyor fees are not included. Budget an additional 8–12% of construction cost for professional services.",
  "calc.faq.q4": "Why is there a 12% contingency?",
  "calc.faq.a4": "Cameroon's construction market experiences material price volatility, supply chain delays, and unforeseen site conditions. A 12% contingency is the industry-standard buffer recommended by local quantity surveyors.",
  "calc.faq.q5": "Why does location change the price?",
  "calc.faq.a5": "Labour rates, transport costs, and material availability differ significantly between Yaoundé, Douala, provincial cities, and rural areas. Douala commands a premium due to port access and higher demand.",
  "calc.faq.q6": "What should I do after getting this estimate?",
  "calc.faq.a6": "Contact a licensed architect to design your building, then commission a quantity surveyor to produce a detailed Bill of Quantities. KIVE SARL can manage this entire process for you — contact us for a free consultation.",

  // Services page
  "servicesPage.hero.eyebrow": "What We Offer",
  "servicesPage.hero.title": "Expert Services for Every Stage of Your Project",
  "servicesPage.hero.sub": "From groundbreaking to long-term maintenance — KIVE SARL delivers end-to-end construction and technical services across Cameroon.",
  "servicesPage.overview": "Overview",
  "servicesPage.scope": "Scope of Work",
  "servicesPage.sectors": "Sectors We Serve",
  "servicesPage.faq": "Frequently Asked Questions",
  "servicesPage.quoteBtn": "Request a Quote",
  "servicesPage.quoteModal.title": "Request a Quote",
  "servicesPage.quoteModal.close": "Close",
  "services.hero.eyebrow": "What We Offer",
  "services.hero.title": "Our Services",
  "services.hero.sub": "Four core disciplines delivered by one accountable team. Select a service below to explore full scope, capabilities, and request a quote.",
  "services.tab.construction": "Construction Management",
  "services.tab.maintenance": "Technical Maintenance",
  "services.tab.machinery": "Heavy Machinery Rental",
  "services.tab.sourcing": "Machinery Sourcing",
  "services.breadcrumb.home": "Home",
  "services.breadcrumb.services": "Services",
  "services.detail.overview": "Overview",
  "services.detail.scope": "Scope of Work",
  "services.detail.sectors": "Sectors We Serve",
  "services.detail.faq": "Frequently Asked",
  "services.detail.quoteBtn": "Request a Quote",
  "services.detail.phoneBtn": "Call Us",
  "services.detail.cta.title": "Ready to get started?",
  "services.detail.cta.sub": "Fill out our quote form and a project manager will respond within 24 hours.",
  "services.quoteModal.title": "Request a Quote",
  "services.quoteModal.close": "Close",

  // Projects page
  "projectsPage.hero.eyebrow": "Our Work",
  "projectsPage.hero.title1": "Projects That",
  "projectsPage.hero.title2": "Speak for Themselves.",
  "projectsPage.hero.sub": "From residential villas to institutional campuses and infrastructure works — every project in our portfolio reflects our commitment to quality, precision, and on-time delivery across Cameroon.",
  "projectsPage.gallery.eyebrow": "Portfolio",
  "projectsPage.gallery.title": "Selected Projects",
  "projectsPage.cta.title": "Have a Project in Mind?",
  "projectsPage.cta.sub": "Tell us about your project and we will get back to you with a tailored proposal within 48 hours.",
  "projectsPage.cta.btn": "Request a Free Quote",
  "projectsPage.modal.location": "Location",
  "projectsPage.modal.year": "Year",
  "projectsPage.modal.client": "Client",
  "projectsPage.modal.scope": "Scope",
  "projectsPage.modal.type": "Type",
  "projectsPage.modal.discuss": "Discuss a Similar Project",
  "projects.hero.eyebrow": "Our Work",
  "projects.hero.title1": "Projects That",
  "projects.hero.title2": "Speak for Themselves.",
  "projects.hero.sub": "From residential villas to institutional campuses and infrastructure works — every project in our portfolio reflects our commitment to quality, precision, and on-time delivery across Cameroon.",
  "projects.stats.projects": "Projects Delivered",
  "projects.stats.years": "Years Active",
  "projects.stats.sectors": "Service Sectors",
  "projects.stats.satisfaction": "Client Satisfaction",
  "projects.gallery.eyebrow": "Portfolio",
  "projects.gallery.title": "Selected Projects",
  "projects.gallery.category.all": "All",
  "projects.cta.title": "Have a Project in Mind?",
  "projects.cta.sub": "Tell us about your project and we will get back to you with a tailored proposal within 48 hours.",
  "projects.cta.btn": "Request a Free Quote",
  "projects.modal.location": "Location",
  "projects.modal.year": "Year",
  "projects.modal.client": "Client",
  "projects.modal.scope": "Scope",
  "projects.modal.type": "Type",
  "projects.modal.discuss": "Discuss a Similar Project",
  "projects.featured": "Featured",
  "projects.imageCount": "images",

  // Careers page
  "careersPage.hero.badge": "We're Hiring",
  "careersPage.hero.title1": "Build Cameroon.",
  "careersPage.hero.title2": "Build Your Career.",
  "careersPage.hero.sub": "KIVE SARL is growing. We are looking for skilled, motivated professionals — from engineers and architects to tradespeople and site supervisors — to join our team in Yaoundé and beyond.",
  "careersPage.hero.viewRoles": "View Open Roles",
  "careersPage.hero.submitCV": "Submit Your CV",
  "careersPage.why.eyebrow": "Why KIVE SARL",
  "careersPage.why.title1": "More Than a Job.",
  "careersPage.why.title2": "A Career That Builds Something Real.",
  "careersPage.why.sub": "At KIVE SARL, we believe our people are the foundation of every project we deliver. We offer a professional, respectful environment where skill is recognised, growth is supported, and every team member plays a meaningful role in shaping Cameroon's built environment.",
  "careersPage.why.joinBtn": "Join Our Team",
  "careersPage.roles.eyebrow": "Open Positions",
  "careersPage.roles.title": "Current Opportunities",
  "careersPage.roles.sub": "We are actively recruiting across multiple disciplines. If your skill set is not listed below, you are still encouraged to submit a general application — we always want to hear from talented professionals.",
  "careersPage.roles.responsibilities": "Key Responsibilities",
  "careersPage.roles.requirements": "What We're Looking For",
  "careersPage.roles.applyBtn": "Apply for This Role",
  "careersPage.form.eyebrow": "Apply Now",
  "careersPage.form.title1": "Ready to Join",
  "careersPage.form.title2": "Our Team?",
  "careersPage.form.sub": "Fill in the form and we will review your application personally. Whether you're an experienced engineer or a skilled tradesperson, we want to hear from you.",
  "careersPage.form.emailLabel": "Career Enquiries",
  "careersPage.form.emailNote": "Prefer to apply by email? Send your CV and a short cover letter to our careers team directly. We respond to all applications within 5 business days.",
  "careersPage.form.nextTitle": "What Happens Next?",
  "careersPage.form.step1": "We review your application within 5 business days",
  "careersPage.form.step2": "Shortlisted candidates are contacted for an initial phone interview",
  "careersPage.form.step3": "A technical or practical assessment may follow",
  "careersPage.form.step4": "Successful candidates receive a formal offer from our HR team",
  "careersPage.form.formTitle": "Application Form",
  "careersPage.form.required": "Fields marked with * are required.",
  "careersPage.form.firstName": "First Name",
  "careersPage.form.lastName": "Last Name",
  "careersPage.form.email": "Email Address",
  "careersPage.form.phone": "Phone Number",
  "careersPage.form.position": "Position Applying For",
  "careersPage.form.positionPlaceholder": "Select a position...",
  "careersPage.form.experience": "Years of Experience",
  "careersPage.form.location": "Current Location",
  "careersPage.form.portfolio": "LinkedIn Profile or Portfolio URL",
  "careersPage.form.coverLetter": "Cover Letter / Message",
  "careersPage.form.cvNote": "To share your CV, please email it directly to careers@kive-cm.com with your name and desired position in the subject line.",
  "careersPage.form.submit": "Submit Application",
  "careersPage.form.submitting": "Submitting Application...",
  "careersPage.form.successTitle": "Application Received!",
  "careersPage.form.successSub": "Thank you for your interest in joining KIVE SARL. We have received your application and will be in touch within 5 business days.",
  "careers.hero.badge": "We're Hiring",
  "careers.hero.title1": "Build Cameroon.",
  "careers.hero.title2": "Build Your Career.",
  "careers.hero.sub": "KIVE SARL is growing. We are looking for skilled, motivated professionals — from engineers and architects to tradespeople and site supervisors — to join our team in Yaoundé and beyond.",
  "careers.hero.viewRoles": "View Open Roles",
  "careers.hero.submitCV": "Submit Your CV",
  "careers.why.eyebrow": "Why KIVE SARL",
  "careers.why.title1": "More Than a Job.",
  "careers.why.title2": "A Career That Builds Something Real.",
  "careers.why.sub": "At KIVE SARL, we believe our people are the foundation of every project we deliver. We offer a professional, respectful environment where skill is recognised, growth is supported, and every team member plays a meaningful role in shaping Cameroon's built environment.",
  "careers.why.joinBtn": "Join Our Team",
  "careers.roles.eyebrow": "Open Positions",
  "careers.roles.title": "Current Opportunities",
  "careers.roles.sub": "We are actively recruiting across multiple disciplines. If your skill set is not listed below, you are still encouraged to submit a general application — we always want to hear from talented professionals.",
  "careers.roles.responsibilities": "Key Responsibilities",
  "careers.roles.requirements": "What We're Looking For",
  "careers.roles.applyBtn": "Apply for This Role",
  "careers.form.eyebrow": "Apply Now",
  "careers.form.title1": "Ready to Join",
  "careers.form.title2": "Our Team?",
  "careers.form.sub": "Fill in the form and we will review your application personally. Whether you're an experienced engineer or a skilled tradesperson, we want to hear from you.",
  "careers.form.emailLabel": "Career Enquiries",
  "careers.form.emailNote": "Prefer to apply by email? Send your CV and a short cover letter to our careers team directly. We respond to all applications within 5 business days.",
  "careers.form.nextTitle": "What Happens Next?",
  "careers.form.step1": "We review your application within 5 business days",
  "careers.form.step2": "Shortlisted candidates are contacted for an initial phone interview",
  "careers.form.step3": "A technical or practical assessment may follow",
  "careers.form.step4": "Successful candidates receive a formal offer from our HR team",
  "careers.form.formTitle": "Application Form",
  "careers.form.required": "Fields marked with * are required.",
  "careers.form.firstName": "First Name",
  "careers.form.lastName": "Last Name",
  "careers.form.email": "Email Address",
  "careers.form.phone": "Phone Number",
  "careers.form.position": "Position Applying For",
  "careers.form.positionPlaceholder": "Select a position...",
  "careers.form.experience": "Years of Experience",
  "careers.form.location": "Current Location",
  "careers.form.portfolio": "LinkedIn Profile or Portfolio URL",
  "careers.form.coverLetter": "Cover Letter / Message",
  "careers.form.cvNote": "To share your CV, please email it directly to careers@kive-cm.com with your name and desired position in the subject line.",
  "careers.form.submit": "Submit Application",
  "careers.form.submitting": "Submitting Application...",
  "careers.form.successTitle": "Application Received!",
  "careers.form.successSub": "Thank you for your interest in joining KIVE SARL. We have received your application and will be in touch within 5 business days.",

  // Home components
  "home.services.eyebrow": "Our Services",
  "home.services.title": "What We Do Best",
  "home.services.sub": "Four core disciplines. One accountable team. Built for demanding projects in Cameroon.",
  "home.services.detailsBtn": "Full Service Details",
  "home.services.quoteBtn": "Get a Quote",
  "home.partners.eyebrow": "Trusted By",
  "home.partners.title": "Partners & Clients",

  // About page
  "about.hero.eyebrow": "About KIVE SARL",
  "about.hero.title1": "Built on Expertise.",
  "about.hero.title2": "Driven by Results.",
  "about.hero.sub": "Since 2007, KIVE SARL has been shaping Cameroon's built environment — delivering complex construction and maintenance projects for governments, institutions, and private clients across the country and beyond.",
  "about.story.eyebrow": "Our Story",
  "about.story.title": "An Engineering Firm Built on Accountability",
  "about.story.p1": "KIVE SARL was founded in Yaoundé with a simple but ambitious mission: to raise the standard of construction delivery in Cameroon. Over nearly two decades, we have grown from a local contractor into a multi-disciplinary technical services company trusted by some of the country's most demanding clients — including government agencies, international NGOs, and leading private developers.",
  "about.story.p2": "Our approach has always been the same: rigorous planning, transparent communication, and uncompromising quality at every stage. We do not cut corners. We do not overpromise. We deliver.",
  "about.people.eyebrow": "Our People",
  "about.people.title": "The People Behind Every Project",
  "about.people.p": "Behind every successful project is a team of committed professionals. Our engineers, project managers, site supervisors, and technical staff bring decades of combined experience to every job. We invest in training, promote from within, and build careers — not just buildings.",
  "about.values.eyebrow": "How We Work",
  "about.values.title": "Values That Guide Every Project",
  "about.values.accountability": "Accountability",
  "about.values.accountability.desc": "We own every decision and every outcome on our projects.",
  "about.values.innovation": "Innovation",
  "about.values.innovation.desc": "We continuously seek better methods, materials, and processes.",
  "about.values.integrity": "Integrity",
  "about.values.integrity.desc": "Transparent communication with clients, partners, and regulators.",
  "about.values.excellence": "Excellence",
  "about.values.excellence.desc": "No shortcuts. Every deliverable meets or exceeds specification.",
  "about.stats.experience": "Years of Experience",
  "about.stats.projects": "Projects Delivered",
  "about.stats.services": "Core Services",
  "about.stats.satisfaction": "Client Satisfaction",
  "about.cta.title": "Ready to Work With Us?",
  "about.cta.sub": "Whether you have a detailed brief or just an idea, our team is ready to discuss your project and provide expert guidance.",
  "about.cta.btn": "Contact Our Team",

  "legal.privacy": "Privacy Policy",
};

export default en;